import React from 'react'; 
import './CarCal.css'

import { Fab, Button, Hidden, Switch } from '@material-ui/core';


export default class CarMonth extends React.Component{

    constructor(props){
        super(props);

        this.state={
            title : '',
           bullet:true
        }

    }




    monthDisplay=(luna, anul)=>{

        let monthBegin = new Date(anul, (luna-1) , 1 ) // js index luna este 0
        let monthEnd = new Date(anul, luna , 0 )

        // console.log('Inceput luna este -> ', monthBegin )
        // console.log('Sfarsit luna este -> ', monthEnd )

        let beginFor = this.getWeekNumber(monthBegin, luna);
        let endFor = this.getWeekNumber(monthEnd, luna) ;

      

        // console.log('begin for =',beginFor);
        // console.log('end for = ',endFor);

        let tbodyContent=[]
        let _td = new Date()
        let _day = 0;

        for(let i = beginFor; i<=endFor; i++){
            let cols = []
            
            for(let k=1; k<=7; k++){

                let celContent=[] 

                for(let j=0; j< monthEnd.getDate() ; j++){

                    _td = this.addDays(monthBegin,j)
                    _day = _td.getDay()===0 ? 7 : _td.getDay()

                    if(this.getWeekNumber(_td, luna)===i && _day===k){
                        // doar display brut de calendar
                        //celContent.push(<label key={`i=${i}k=${k}j=${j}`}>{_td.getDate()}</label>)
// console.log('this.props.dataProgramare :', this.props.dataProgramare.substring());
// console.log('_td :', _td);
                        celContent.push(<div  style={{backgroundColor:!this.state.bullet ?( this.getCarData(_td) ? this.getCarData(_td).bgColor : '') : '', overflow:'hidden' , position:'relative'}}  className={_day >=6 ? 'monthcalendar-weekend-class' : 'monthcalendar-weekday-class'} key={`i=${i}k=${k}j=${j}`}>
                            
                            <div style={{width:'fit-content', margin:'auto', padding:12, backgroundColor:this.state.bullet ?( this.getCarData(_td) ? this.getCarData(_td).bgColor : '') : '', borderRadius:20, textAlign:'center', width:20}}>
                            <label className={_day >=6 ? 'monthcalendar-weekend-label' : 'monthcalendar-weekday-label'} > {_td.getDate()} </label> 

                            </div>
                            <div style={{width: 20, height:20, borderRadius:'50%',display:this.props.today === `${anul}-${luna < 10 ? '0' + luna : luna}-${j + 1 < 10 ? "0" + (j + 1) : j + 1}` ? 'block' : 'none',  position:'absolute', top:2, left:2, backgroundColor:'green'}}></div>
                                
                                    <ul>
                                        {this.getCarData(_td) &&
                                            this.getCarData(_td).requestsList.map((c, idx)=>{
                                              return(
                                                <li key={idx}>{c}</li>
                                              ) 
                                            })}
                                    </ul>
                  
                                        </div>)
                    }
                }

                cols.push(<td  key={`w${i}d${k}`}> {celContent}  </td>)
            }

            tbodyContent.push(<tr key={`w${i}`}>{cols}</tr>)
        }

       
        // console.log('body content',tbodyContent);
         return tbodyContent
    }



     getWeekNumber=(d, luna)=> {

        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        let dayNum= d.getUTCDay() || 7
        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      
        if(weekNo === 1 && luna === 12){
            let ld = new Date(d.getFullYear(), 11, 24);
            return this.getWeekNumber(ld) + 1
        }else{
            return weekNo
        }
    }

    ajustareSfarsitAn=(anul)=>{
            return this.weeksInYear(anul) + 1
    }

   weeksInYear=(year)=> {
        var d = new Date(year, 11, 31);
        var week = this.getWeekNumber(d);
        // console.log('saptamana :', week);
        if(week === 1){
            d.setDate(24)
            return this.getWeekNumber(d)
        }else{
            return week
        }
       
      }





    daysInMonth=(month, year)=> {
        
        return new Date(year, month, 0).getDate();
    }

    addDays=(date, days)=> {

        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    defaultData = (data) => {
   
 
        let myDate = new Date(data)
      
        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth()+1
        let month = ((lunaNormala <10? '0' : '') + lunaNormala );
        let day = (myDate.getDate()<10? '0' : '') +myDate.getDate();
        // console.log('today :', `${year}-${month}-${day}`);
        return `${year}-${month}-${day}`
      
       }

    getCarData = (dt) => {
       

       let dataCalendar = this.defaultData(dt);


        let cloneEvents = this.props.events

      let idx = cloneEvents.findIndex(e => e.dataAsString === dataCalendar)



      if(idx !== -1){

        // console.log('cloneEvents[idx] :',cloneEvents[idx]);
          return cloneEvents[idx]
      }

      else{
          return null
      }



    }

    numeLuna = (l)=>
    {

        // console.log('l :', l);
        let rez =''

        switch(l){
            case 1: rez = this.props.months[0]; break;
            case 2: rez = this.props.months[1]; break;
            case 3: rez = this.props.months[2]; break;
            case 4: rez = this.props.months[3]; break;
            case 5: rez = this.props.months[4]; break;
            case 6: rez = this.props.months[5]; break;
            case 7: rez = this.props.months[6]; break;
            case 8: rez = this.props.months[7]; break;
            case 9: rez = this.props.months[8]; break;
            case 10: rez= this.props.months[9]; break;
            case 11: rez = this.props.months[10]; break;
            case 12: rez = this.props.months[11]; break;

        }

        return rez
    }


    render(){
        return (
            <div style={{display:this.props.display, maxWidth:this.props.maxWidth}} className="monthcalendar-main-container">

                 <div className='monthcalendar-header'>
                                    <i onClick={this.props.minusLuna} className='material-icons' style={{color:'rgb(117, 234, 117)', verticalAlign:'sub', cursor:'pointer', fontSize:20}}>arrow_back</i>
                                    <span className='monthcalendar-title'>{this.numeLuna(this.props.luna)} - {this.props.anul}</span>
                                    <i onClick={this.props.plusLuna} className='material-icons' style={{color:'rgb(117, 234, 117)', verticalAlign:'sub', cursor:'pointer',fontSize:20}}>arrow_forward</i> 
                                    </div> 
              <div className="monthcalendar-table-container">
                                       
                                     <div style={{marginBottom:20, padding:10}}> 
                                         <span onClick={()=>{this.setState({bullet:true})}} style={{backgroundColor:this.state.bullet ? 'green' : 'white', border:'1px solid gray', padding:3, color:this.state.bullet ? 'white' : 'green'}}>Bullet</span>
                                         <span onClick={()=>{this.setState({bullet:false})}} style={{backgroundColor:!this.state.bullet ? 'green' : 'white',border:'1px solid gray',padding:3,color:!this.state.bullet ? 'white' : 'green', marginLeft:10}}>Background</span>
                                     </div>


                <table className='monthcalendar-table-class'>
                    <thead className='monthcalendar-tablehead-class'>
                    <tr className='monthcalendar-tableheadtr-class' >
                        <th style={{color:'rgb(117, 234, 117)', backgroundColor:'white', fontSize:15}}>{this.props.dayOfWeek[0]}</th>
                        <th style={{color:'rgb(117, 234, 117)',backgroundColor:'white',fontSize:15}}>{this.props.dayOfWeek[1]}</th>
                        <th style={{color:'rgb(117, 234, 117)', backgroundColor:'white',fontSize:15}}>{this.props.dayOfWeek[2]}</th>
                        <th style={{color:'rgb(117, 234, 117)', backgroundColor:'white',fontSize:15}}>{this.props.dayOfWeek[3]}</th>
                        <th style={{color:'rgb(117, 234, 117)', backgroundColor:'white',fontSize:15}}>{this.props.dayOfWeek[4]}</th>
                        <th style={{color:'white', backgroundColor:'rgb(117, 234, 117)',fontSize:15}}>{this.props.dayOfWeek[5]}</th>
                        <th style={{color:'white', backgroundColor:'rgb(117, 234, 117)',fontSize:15}}>{this.props.dayOfWeek[6]}</th>
                    </tr>
                    </thead>

                    <tbody>
                        {this.monthDisplay(this.props.luna, this.props.anul)}
                    </tbody>
                   
                </table>
                </div>
            </div>
        );
    }


}  // end class